import { GoalStoreProps } from "@ctypes";
import { useGoalStore } from "@stores";

export const useGoalFlow = () => {
  const { goalProps, setGoalProps: setGoalPropsFromStore } = useGoalStore();

  const setGoalProps = (newGoalProps: GoalStoreProps) => {
    setGoalPropsFromStore({
      ...goalProps,
      ...newGoalProps,
    });
  };

  const clearGoalProps = () => {
    setGoalPropsFromStore({});
  };

  const resetGoalProps = (newGoalProps: GoalStoreProps) => {
    setGoalPropsFromStore(newGoalProps);
  };

  return { goalProps, setGoalProps, clearGoalProps, resetGoalProps };
};
